import { render, staticRenderFns } from "./FreeProduct.vue?vue&type=template&id=958253ac&scoped=true&"
import script from "./FreeProduct.vue?vue&type=script&lang=js&"
export * from "./FreeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958253ac",
  null
  
)

export default component.exports